/**
 * Created by Nitish Ranjan on 15/10/2018.
 */
export * from './highlight-search.pipe';